const NAMED_OUTPUT_STEP_TYPES = new Set([
  "extract",
  "screenshot",
  "download",
  "extract_cookies",
  "extract_request_headers",
  "extract_url",
  "set_variable",
  "agent",
]);

const NESTED_STEP_KEYS = ["then", "otherwise", "steps"] as const;

/** Output variable names a step list writes, in order, including nested
 * branches and loop bodies. Mirrors the backend `derive_playbook_outputs`:
 * most steps write their `name`, a run_script step every entry of `outputs`. */
export function collectStepOutputNames(steps: unknown[]): string[] {
  const names: string[] = [];
  for (const step of steps) {
    if (!step || typeof step !== "object") continue;
    const s = step as Record<string, unknown>;
    if (s.type === "run_script") {
      if (Array.isArray(s.outputs)) {
        for (const name of s.outputs) {
          if (typeof name === "string" && name) names.push(name);
        }
      }
    } else if (
      typeof s.name === "string" &&
      s.name &&
      typeof s.type === "string" &&
      NAMED_OUTPUT_STEP_TYPES.has(s.type)
    ) {
      names.push(s.name);
    }
    for (const key of NESTED_STEP_KEYS) {
      const nested = s[key];
      if (Array.isArray(nested)) names.push(...collectStepOutputNames(nested));
    }
  }
  return names;
}
